import InputCus from "../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  // ProductChangeOrderProduct,
  ProductFilterBerand,
  ProductFilterColor,
  ProductFilterCountry,
  ProductFilterProduct,
  ProductFilterType,
  ProductFilterSeries,
  ProductFilterSeriesEnd,
  ProductFilterRam,
  ProductFilterRom,
  ProductFilterNetwork,
  ProductDeleteProduct,
  ProductChangeActiveProduct,
} from "../../Api/Services";
import imgDelete from "../../assets/Icon/icons8-remove-100.png";
import imgDoc from "../../assets/Icon/icons8-edit-48.png";
import { confirmAlert } from "react-confirm-alert";
import imgPlus from "../../assets/Icon/pluse.png";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "../../Component/InputCus/Select/Select";
import sync from "../../assets/Icon/icons8-sync-50.png";

function Product() {
  const [Search, setSearch] = useState({});
  const [Data, setData] = useState([]);
  const [productType, setProductType] = useState([]);
  const [productNetwork, setproductNetwork] = useState([]);
  const [productSeriesEnd, setproductSeriesEnd] = useState([]);
  const [productSeries, setproductSeries] = useState([]);
  const [productRam, setproductRam] = useState([]);
  const [productRom, setproductRom] = useState([]);
  const [productCountry, setProductCountry] = useState([]);
  const [productColor, setProductColor] = useState([]);
  const [productBerand, setProductBerand] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();

  const start = async () => {
    try {
      const ProductFilterProductData = await ProductFilterProduct({});
      if (
        ProductFilterProductData.status &&
        ProductFilterProductData.status === 200
      ) {
        setData(ProductFilterProductData.data.data.data);
        const ProductFilterTypeData = await ProductFilterType({});
        if (
          ProductFilterTypeData.status &&
          ProductFilterTypeData.status === 200
        ) {
          setProductType(ProductFilterTypeData.data.data.data);
          const ProductFilterSeriesData = await ProductFilterSeries({});
          if (
            ProductFilterSeriesData.status &&
            ProductFilterSeriesData.status === 200
          ) {
            setproductSeries(ProductFilterSeriesData.data.data.data);
            const ProductFilterSeriesEndData = await ProductFilterSeriesEnd({});
            if (
              ProductFilterSeriesEndData.status &&
              ProductFilterSeriesEndData.status === 200
            ) {
              setproductSeriesEnd(ProductFilterSeriesEndData.data.data.data);

              const ProductFilterRamData = await ProductFilterRam({});
              if (
                ProductFilterRamData.status &&
                ProductFilterRamData.status === 200
              ) {
                setproductRam(ProductFilterRamData.data.data.data);

                const ProductFilterRomData = await ProductFilterRom({});
                if (
                  ProductFilterRomData.status &&
                  ProductFilterRomData.status === 200
                ) {
                  setproductRom(ProductFilterRomData.data.data.data);

                  const ProductFilterNetworkData = await ProductFilterNetwork(
                    {}
                  );
                  if (
                    ProductFilterNetworkData.status &&
                    ProductFilterNetworkData.status === 200
                  ) {
                    setproductNetwork(ProductFilterNetworkData.data.data.data);

                    const ProductFilterCountryData = await ProductFilterCountry(
                      {}
                    );
                    if (
                      ProductFilterCountryData.status &&
                      ProductFilterCountryData.status === 200
                    ) {
                      setProductCountry(
                        ProductFilterCountryData.data.data.data
                      );
                      const ProductFilterColorData = await ProductFilterColor(
                        {}
                      );
                      if (
                        ProductFilterColorData.status &&
                        ProductFilterColorData.status === 200
                      ) {
                        setProductColor(ProductFilterColorData.data.data.data);
                        const ProductFilterBerandData =
                          await ProductFilterBerand({});
                        if (
                          ProductFilterBerandData.status &&
                          ProductFilterBerandData.status === 200
                        ) {
                          setProductBerand(
                            ProductFilterBerandData.data.data.data
                          );
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const Clear = async () => {
    setSearch({});
    setLoading(true);
    try {
      const ProductFilterProductData = await ProductFilterProduct({});
      if (
        ProductFilterProductData.status &&
        ProductFilterProductData.status === 200
      ) {
        setData(ProductFilterProductData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const Searched = async () => {
    try {
      setLoading(true);
      const ProductFilterProductData = await ProductFilterProduct({
        ...Search,
      });
      if (
        ProductFilterProductData.status &&
        ProductFilterProductData.status === 200
      ) {
        setData(ProductFilterProductData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const confirmDelete = (e) => {
    confirmAlert({
      title: "حذف کالا",
      message: "آیا مطمئن هستید ؟",
      buttons: [
        {
          label: "بله",
          onClick: () => DeleteItem(e),
        },
        {
          label: "خیر",
        },
      ],
    });
  };

  const DeleteItem = async (e) => {
    try {
      setLoading(true);
      const ProductDeleteProductData = await ProductDeleteProduct(e);
      if (
        ProductDeleteProductData.status &&
        ProductDeleteProductData.status === 200
      ) {
        toast.success("عملیات با موفقیت انجام شد");
        await start();
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const Add = () => {
    navigate("/Panel/Products/Add");
  };
  const AddColor = () => {
    navigate("/Panel/Products/AddColor");
  };

  const Edite = (id) => {
    navigate("/Panel/Products/Edite/" + id);
  };

  const ChandeOrder = async (e) => {
    const newSearch = [...Data];
    newSearch.find((w) => w.id == e.target.id).order = e.target.value;
    setData(newSearch);
  };

  // const FixChandeOrder = async (e) => {
  //   if (e.key == "Enter") {
  //     try {
  //       setLoading(true);
  //       const ProductChangeOrderProductData = await ProductChangeOrderProduct({
  //         id: e.target.id,
  //         order: e.target.value,
  //       });
  //       if (
  //         ProductChangeOrderProductData.status &&
  //         ProductChangeOrderProductData.status === 200
  //       ) {
  //         toast.success("عملیات با موفقیت انجام شد");
  //         await start();
  //       }
  //     } catch (error) {
  //       console.error("Error during login:", error);
  //     } finally {
  //     }
  //   }
  // };

  const handleChangeSearch = (e) => {
    const newSearch = { ...Search };
    newSearch[e.target.id] = e.target.value;
    setSearch(newSearch);
  };

  const confirmProductChangeActive = (e) => {
    confirmAlert({
      title: "تغییر وضعیت محصول",
      message: "آیا مطمئن هستید ؟",
      buttons: [
        {
          label: "بله",
          onClick: () => ActiveItem(e),
        },
        {
          label: "خیر",
        },
      ],
    });
  };

  const ActiveItem = async (e) => {
    try {
      setLoading(true);
      const ProductChangeActiveProductData = await ProductChangeActiveProduct(
        e
      );
      if (
        ProductChangeActiveProductData.status &&
        ProductChangeActiveProductData.status === 200
      ) {
        toast.success("عملیات با موفقیت انجام شد");
        await start();
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="d-flex justify-content-start align-items-center w-100 mb-5 pointer">
            <img
              onClick={() => {
                Add();
              }}
              src={imgPlus}
              alt=""
            />
            <div className="border border-3 border-black bg-warning d-flex justify-content-center align-items-center m-1 p-1 ">
              <span className="m-1 p-1">رنگی</span>
              <img
                onClick={() => {
                  AddColor();
                }}
                src={imgPlus}
                alt=""
              />
            </div>
            <div className="w-100 d-flex justify-content-end">
              <button
                onClick={() => {
                  navigate("/Panel/Products/Berand");
                }}
                className="m-2 border rounded-5 h6 ps-3 pe-3 pt-1 pb-2"
              >
                برند
              </button>
              <button
                onClick={() => {
                  navigate("/Panel/Products/Color");
                }}
                className="m-2 border rounded-5 h6 ps-3 pe-3 pt-1 pb-2"
              >
                رنگ
              </button>
              <button
                onClick={() => {
                  navigate("/Panel/Products/Type");
                }}
                className="m-2 border rounded-5 h6 ps-3 pe-3 pt-1 pb-2"
              >
                نوع
              </button>
              <button
                onClick={() => {
                  navigate("/Panel/Products/Series");
                }}
                className="m-2 border rounded-5 h6 ps-3 pe-3 pt-1 pb-2"
              >
                سری
              </button>
              <button
                onClick={() => {
                  navigate("/Panel/Products/SeriesEnd");
                }}
                className="m-2 border rounded-5 h6 ps-3 pe-3 pt-1 pb-2"
              >
                سری دوم
              </button>
              <button
                onClick={() => {
                  navigate("/Panel/Products/Ram");
                }}
                className="m-2 border rounded-5 h6 ps-3 pe-3 pt-1 pb-2"
              >
                رم
              </button>
              <button
                onClick={() => {
                  navigate("/Panel/Products/Rom");
                }}
                className="m-2 border rounded-5 h6 ps-3 pe-3 pt-1 pb-2"
              >
                رام
              </button>
              <button
                onClick={() => {
                  navigate("/Panel/Products/Network");
                }}
                className="m-2 border rounded-5 h6 ps-3 pe-3 pt-1 pb-2"
              >
                شبکه
              </button>
              <button
                onClick={() => {
                  navigate("/Panel/Products/Country");
                }}
                className="m-2 border rounded-5 h6 ps-3 pe-3 pt-1 pb-2"
              >
                کشور
              </button>
            </div>
          </div>
          <div className="d-flex justify-content-start align-items-center flex-wrap">
            <InputCus
              type="text"
              name="name"
              id="name"
              text="نام"
              className="m-2"
              value={Search.name || ""}
              onChange={handleChangeSearch}
            />
            <InputCus
              type="text"
              name="symbol"
              id="symbol"
              text="سیمبل"
              className="m-2"
              value={Search.symbol || ""}
              onChange={handleChangeSearch}
            />
            <Select
              className="m-2"
              type="number"
              name="productColorId"
              id="productColorId"
              text="رنگ"
              value={Search.productColorId || ""}
              onChange={handleChangeSearch}
              option={productColor.map((item) => {
                let data = {
                  value: item.id,
                  title: item.name,
                };
                return data;
              })}
            />
            <Select
              className="m-2"
              type="number"
              name="productBerandId"
              id="productBerandId"
              text="برند"
              value={Search.productBerandId || ""}
              onChange={handleChangeSearch}
              option={productBerand.map((item) => {
                let data = {
                  value: item.id,
                  title: item.name,
                };
                return data;
              })}
            />
            <Select
              className="m-2"
              type="number"
              name="productCountryId"
              id="productCountryId"
              text="کشور"
              value={Search.productCountryId || ""}
              onChange={handleChangeSearch}
              option={productCountry.map((item) => {
                let data = {
                  value: item.id,
                  title: item.name,
                };
                return data;
              })}
            />
            <Select
              className="m-2"
              type="number"
              name="productRamId"
              id="productRamId"
              text="رم"
              value={Search.productRamId || ""}
              onChange={handleChangeSearch}
              option={productRam.map((item) => {
                let data = {
                  value: item.id,
                  title: item.name,
                };
                return data;
              })}
            />
            <Select
              className="m-2"
              type="number"
              name="productRomId"
              id="productRomId"
              text="رام"
              value={Search.productRomId || ""}
              onChange={handleChangeSearch}
              option={productRom.map((item) => {
                let data = {
                  value: item.id,
                  title: item.name,
                };
                return data;
              })}
            />
            <Select
              className="m-2"
              type="number"
              name="productSeriesId"
              id="productSeriesId"
              text="سری"
              value={Search.productSeriesId || ""}
              onChange={handleChangeSearch}
              option={productSeries.map((item) => {
                let data = {
                  value: item.id,
                  title: item.name,
                };
                return data;
              })}
            />
            <Select
              className="m-2"
              type="number"
              name="productSeriesEndId"
              id="productSeriesEndId"
              text="سری دوم"
              value={Search.productSeriesEndId || ""}
              onChange={handleChangeSearch}
              option={productSeriesEnd.map((item) => {
                let data = {
                  value: item.id,
                  title: item.name,
                };
                return data;
              })}
            />
            <Select
              className="m-2"
              type="number"
              name="productNetworkId"
              id="productNetworkId"
              text="شبکه"
              value={Search.productNetworkId || ""}
              onChange={handleChangeSearch}
              option={productNetwork.map((item) => {
                let data = {
                  value: item.id,
                  title: item.name,
                };
                return data;
              })}
            />
            <Select
              className="m-2"
              type="number"
              name="productTypeId"
              id="productTypeId"
              text="نوع"
              value={Search.productTypeId || ""}
              onChange={handleChangeSearch}
              option={productType.map((item) => {
                let data = {
                  value: item.id,
                  title: item.name,
                };
                return data;
              })}
            />
            <Select
              type="text"
              name="isActived"
              id="isActived"
              text="وضعیت"
              value={Search.isActived || ""}
              onChange={handleChangeSearch}
              className="m-2"
              option={[
                { value: true, title: "فعال" },
                { value: false, title: "غیرفعال" },
              ]}
            />
            <Select
              type="text"
              name="isInsurance"
              id="isInsurance"
              text="بیمه"
              value={Search.isInsurance || ""}
              onChange={handleChangeSearch}
              className="m-2"
              option={[
                {
                  value: false,
                  title: "ندارد",
                },
                {
                  value: true,
                  title: "دارد",
                },
              ]}
            />
          </div>
          <div className="d-flex justify-content-between align-items-center w-100 mb-3">
            <div onClick={Searched} className="btnSearch">
              جست و جو
            </div>
            <div onClick={Clear} className="btnCancel">
              بروزرسانی
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center w-100 p-2 tableC">
            <table className="table">
              <thead className="sticky-header">
                <tr className="trTable">
                  {/* <th>الویت نمایش</th> */}
                  <th>نام</th>
                  <th>سیمبل</th>
                  <th>رنگ</th>
                  <th>برند</th>
                  <th>کشور</th>
                  <th>نوع</th>
                  <th>رم</th>
                  <th>رام</th>
                  <th>شبکه</th>
                  <th>سری</th>
                  <th>سری دوم</th>
                  <th>وضعیت</th>
                  <th>بیمه</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {Data.map((item, key) => (
                  <tr key={key}>
                    {/* <td>
                      <input
                        id={item.id}
                        className="w-25"
                        value={item.order}
                        onKeyUp={(e) => FixChandeOrder(e)}
                        onChange={(e) => ChandeOrder(e)}
                      />
                    </td> */}
                    <td>{item.name}</td>
                    <td>{item.symbol}</td>
                    <td>{item.productColorName}</td>
                    <td>{item.productBerandName}</td>
                    <td>{item.productCountryName}</td>
                    <td>{item.productTypeName}</td>
                    <td>{item.productRamName}</td>
                    <td>{item.productRomName}</td>
                    <td>{item.productNetworkName}</td>
                    <td>{item.productSeriesName}</td>
                    <td>{item.productSeriesEndName}</td>
                    {item.isActived ? (
                      <td className="text-success">
                        فعال
                        <span
                          className="d-inline-block pointer ms-2"
                          tabIndex="0"
                          data-bs-toggle="tooltip"
                          title="تغییر"
                        >
                          <img
                            height="30"
                            className="me-2"
                            src={sync}
                            alt="تغییر"
                            onClick={() => {
                              confirmProductChangeActive(item.id);
                            }}
                          />
                        </span>
                      </td>
                    ) : (
                      <td className="text-danger">
                        غیر فعال
                        <span
                          className="d-inline-block pointer ms-2"
                          tabIndex="0"
                          data-bs-toggle="tooltip"
                          title="تغییر"
                        >
                          <img
                            height="30"
                            className="me-2"
                            src={sync}
                            alt="تغییر"
                            onClick={() => {
                              confirmProductChangeActive(item.id);
                            }}
                          />
                        </span>
                      </td>
                    )}
                    {item.isInsurance ? (
                      <td className="text-success">دارد</td>
                    ) : (
                      <td className="text-danger">ندارد</td>
                    )}
                    <td className="td-actions">
                      <span
                        className="d-inline-block pointer ms-2"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="حذف"
                      >
                        <img
                          height="30"
                          className="me-2"
                          src={imgDelete}
                          alt="حذف"
                          onClick={() => {
                            confirmDelete(item.id);
                          }}
                        />
                      </span>
                      <span
                        className="d-inline-block pointer"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="ویرایش"
                      >
                        <img
                          height="30"
                          src={imgDoc}
                          alt="ویرایش"
                          onClick={() => {
                            Edite(item.id);
                          }}
                        />
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Product;
